// extracted by mini-css-extract-plugin
export default {"loginForm":"loginForm_loginForm__239HZ","forgotLink":"loginForm_forgotLink__5wNLH","registerLink":"loginForm_registerLink__UIDNU","register":"loginForm_register__Dy2qL"};